module.exports = __webpack_public_path__ + "img/red-van.d7abbdac.png";